import { LoadingButton } from "@mui/lab";
import { Box, Grid, Link, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import StyledOrDivider from "components/OrDivider";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

interface Props {
  checkoutUgcBundle: () => Promise<void>;
  fetchUserLoading: boolean;
}

const ProgramInfo = ({ checkoutUgcBundle, fetchUserLoading }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription } = useContext(SubscriptionContext);

  const clickGo = async () => {
    if (subscription && subscription.ouiStudioData) {
      navigate(`/${routes.home}${location.search}`);
      return;
    }
    trackEvent("Pitch Please - Let's Go Button Clicked");
    if (currentOrg?.id) {
      await checkoutUgcBundle();
    } else {
      navigate(`/${routes.pitchPleaseSignUp}${location.search}`);
    }
  };

  return (
    <Box sx={{ my: 3, px: { xs: 2, md: 6, lg: 10 } }}>
      <Typography
        variant="h2"
        sx={styles.header}
        textAlign="center"
        component="div"
      >
        <strong>
          Out-of-Office Club{" "}
          <Box
            component="span"
            sx={{ color: "#f6adaa", fontSize: 20, my: "-20px", opacity: 0.5 }}
          >
            x
          </Box>{" "}
          Bento
        </strong>
      </Typography>

      <Box sx={{ my: { xs: 2, md: 6 } }}>
        <StyledOrDivider text="What you'll get" />
      </Box>

      <Link
        sx={styles.link}
        href="https://www.ouiwestudio.com/ooo"
        target="_blank"
      >
        <strong>
          Oui, We Studio's Out-of-Office Club{" "}
          <Box
            component="i"
            className="fa-regular fa-arrow-up-right-from-square"
          />
          <br />
        </strong>
      </Link>
      <ul>
        <li>
          {" "}
          Monthly OOO Labs, workshops + challenges with a network of content
          creators world wide
        </li>
        <li>Private AMAs and a library of expert resources</li>
        <li>
          Plus! Surprises in the works like how to film b-roll, the Smart Girl
          content repurposing guide, CapCut editing tutorials etc.
        </li>
        <li>
          Smart strategies to DIY your growth (from creative mindset tips to
          exclusive AI prompts)
        </li>
      </ul>

      <Link sx={styles.link} href="https://www.onbento.com/va" target="_blank">
        <strong>
          Bento's Virtual Assistant{" "}
          <Box
            component="i"
            className="fa-regular fa-arrow-up-right-from-square"
          />
          <br />
        </strong>
      </Link>

      <ul>
        <li> Get all of your pitching needs done for you with Bento's AI!</li>
        <li>Over 300 pitches sent on your behalf in your select niches</li>
        <li>
          Over 300 follow ups automatically sent for you so you land more
          responses
        </li>
        <li>
          Local brand pitching to any and all of your favorite restaurants,
          spas, gyms and more!
        </li>
        <li>
          Custom metrics for you- see how your email pitches and deals rates
          compare to your peers!
        </li>
        <li>
          Perfect for anyone who hates pitching, has a day job, or would rather
          spend their time on creative work than in their inbox.
        </li>
      </ul>

      <Grid container justifyContent="center" sx={{ my: 3 }}>
        <LoadingButton
          disableElevation
          variant="contained"
          sx={styles.letGoButton}
          onClick={clickGo}
          loading={fetchUserLoading}
        >
          Let's go{" "}
          <Box
            sx={{ ml: 1 }}
            component="i"
            className="fa-regular fa-arrow-right"
          />
        </LoadingButton>
      </Grid>
    </Box>
  );
};

export default ProgramInfo;
